export default "__VITE_ASSET__DRNzb5JU__"